var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.79316 4.28177C9.23125 4.27471 8.67086 4.34195 8.12657 4.48176C5.69928 5.08988 3.35791 6.98683 1.77799 8.91859C1.5726 9.1797 1.46094 9.50226 1.46094 9.83447C1.46094 10.1667 1.5726 10.4892 1.77799 10.7504C3.33347 12.6495 5.66891 14.5798 8.12953 15.1946C8.67304 15.333 9.23236 15.3995 9.79316 15.3924C10.355 15.3997 10.9153 15.3332 11.4597 15.1946C13.9204 14.582 16.258 12.651 17.8106 10.7504C18.0159 10.4892 18.1276 10.1667 18.1276 9.83447C18.1276 9.50226 18.0159 9.1797 17.8106 8.91859C16.2299 6.98609 13.8848 5.08914 11.4597 4.48102C10.9154 4.34158 10.355 4.27459 9.79316 4.28177V4.28177Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92726 17.0709C2.63436 16.778 2.63436 16.3031 2.92726 16.0102L16.0087 2.92877C16.3016 2.63587 16.7765 2.63587 17.0694 2.92877C17.3623 3.22166 17.3623 3.69653 17.0694 3.98943L3.98792 17.0709C3.69502 17.3638 3.22015 17.3638 2.92726 17.0709Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 431",
    cx: 9.79088,
    cy: 9.62877,
    rx: 1.619,
    ry: 1.619,
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEyeClose);
export default __webpack_public_path__ + "static/media/passEyeClose.6e475992325e44b876313656f68b3d5a.svg";
export { ForwardRef as ReactComponent };